
<template>
    <div class="scroll-container">
        <DsListItem
            v-for="element in elements"
            :key="element.cell.id"
            :title="element.displayLabel"
            :description="element.name"
            clickable
            data-qa="automation-element"
            @click="$emit('click', element.cell)"
        >
            <template #leading>
                <img
                    :width="24"
                    :height="24"
                    :src="element.iconSrc"
                    :alt="`${element.cell.type} icon`"
                />
            </template>

            <template #trailing>
                <DsStatus :type="element.isBroken ? 'error' : (element.setupRequired ? 'warning' : 'default')">
                    {{ element.status }}
                </DsStatus>
            </template>
        </DsListItem>
    </div>
</template>

<script>
export default {
    props: {
        elements: {
            type: Array,
            default: () => ([]),
        },
    },
};
</script>

<style lang="scss" scoped>
.scroll-container {
    overflow-y: auto;
    height: calc(100% - 120px);
}
</style>
